<template>
    <Link
        :href="href"
        class="block px-4 py-2 focus:outline-none transition"
        :class="linkClasses"
        v-if="linkType == 'inertia'"
    >
        <slot />
    </Link>
    <a
        :href="href"
        class="block px-4 py-2 focus:outline-none transition"
        :class="linkClasses"
        :target="target"
        v-else
    >
        <slot />
    </a>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Link,
    },
    props: {
        href: {
            type: String,
        },
        target: {
            type: String,
            default: '_blank'
        },
        active: {
            type: Boolean,
        },
        parent: {
            type: Boolean,
        },
        visible: {
            type: Boolean,
        },
        linkType: {
            type: String,
            default: 'inertia',//regular, normal, anything but inertia
        },
    },
    data() {
        return {
            linkClasses : '',
        }
    },
    mounted() {
        if (this.active) {
            this.linkClasses = 'bg-purple-500 text-purple-100 focus:text-purple-100';
        } else {
            this.linkClasses = 'text-white hover:bg-purple-500 hover:text-purple-100 focus:text-white';
        }

        if (!this.parent){
            this.linkClasses += ' pl-9';
        }
    }
}
</script>
